export default __webpack_public_path__ + "static/media/IMG_5040.7e9ad251.png";